var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscribeFooter"},[_c('div',{staticClass:"btn-container"},[_c('rich-button',{on:{"click":_vm.joinSubscribe}},[_vm._v(" "+_vm._s(_vm.$t('FoodC_V2_NigJ_XaWd', {didipackbrand: _vm.brandName}))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }